import { useEffect } from "react";
import "./Blog.scss";

function Blog() {
	useEffect(() => {
		// 1. Create the script element
		const script = document.createElement('script');

		// 2. Build the URL with the logic from your snippet
		const params = new URLSearchParams(window.location.search);
		let url = 'https://app.trysoro.com/api/embed/747474ad-a832-48c3-a999-d83e2b06eaa2?theme=dark';

		if (params.get('post')) {
			url += '&post=' + encodeURIComponent(params.get('post'));
		}

		script.src = url;
		script.async = true;

		// 3. Find the target div and append the script after it
		const target = document.getElementById('soro-blog');
		if (target) {
			target.insertAdjacentElement('afterend', script);
		}

		// Optional: Cleanup script when user leaves the page
		return () => {
			if (script.parentNode) {
				script.parentNode.removeChild(script);
			}
		};
	}, []);
	return (
		<div className="blog-container">
			<div id="soro-blog"></div>
		</div>
	)
}

export default Blog;